export default "__VITE_ASSET__BlypeOxu__"